import { useState, useCallback } from "react";

const useBreadcrumb = () => {
  const [breadcrumbSlug, setBreadcrumbSlug] = useState("");

  const handleBreadcrumb = (nodeData, apiresponse, slug) => {
    if (slug) {
      setBreadcrumbSlug(slug);
      let breadcrumbItems = [];
      if (nodeData?.parent_id === 0) {
        breadcrumbItems.push({ folderName: nodeData?.folder_name, folderId: nodeData?.id });
        return breadcrumbItems;
      } else {
        const traverse = (nodes, parentId) => {
          for (const node of nodes) {
            if (node.id === parentId) {
              breadcrumbItems.push({ folderName: node.folder_name, folderId: node.id });
              traverse(apiresponse, node?.parent_id);
              break;
            }
          }
        };
        traverse(apiresponse, nodeData?.id);
        return breadcrumbItems.reverse();
      }
    } else {
      setBreadcrumbSlug("");
      let breadcrumbItems = [];
      if (nodeData?.parent_id === 0) {
        return breadcrumbItems;
      } else {
        const traverse = (nodes, parentId) => {
          for (const node of nodes) {
            if (node.id === parentId) {
              breadcrumbItems.push({ folderName: node.folder_name, folderId: node.id });
              traverse(apiresponse, node?.parent_id);
              break;
            }
          }
        };
        traverse(apiresponse, nodeData?.parent_id);

        return breadcrumbItems.reverse();
      }
    }
  };

  return { breadcrumbSlug, setBreadcrumbSlug, handleBreadcrumb };
};

export default useBreadcrumb;
